import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { existingIntDataSortSelector } from '@store/serviceIntegrations/existingIntegrations/selectors';
import {
  SummaryWrapper,
  SummaryColumn,
  SummaryColumnHeader,
  SummaryColumnValue,
} from '../styled';

function Summary() {
  const { data } = useSelector(existingIntDataSortSelector);
  const count = useMemo(() => data.reduce((acc, config) => ({
    total: acc.total + 1,
    disabled: config.state === 1 ? acc.disabled + 1 : acc.disabled,
    enabled: config.state === 2 ? acc.enabled + 1 : acc.enabled,
  }), {
    total: 0,
    enabled: 0,
    disabled: 0,
  }), [data]);

  return (
    <SummaryWrapper>
      {
        Object.keys(count).map(key => (
          <SummaryColumn key={key}>
            <SummaryColumnHeader>
              {key}
            </SummaryColumnHeader>
            <SummaryColumnValue>
              {count[key]}
            </SummaryColumnValue>
          </SummaryColumn>
        ))
      }
    </SummaryWrapper>
  );
}

export default Summary;
